(function () {
	'use strict';
	$(document).ready(function () {

		let swiperOptionTitles = [];

		$(".option-one-swiper .swiper-wrapper .swiper-slide").each(function(i) {
			swiperOptionTitles.push($(this).data("title"));
		});

		new Swiper('.option-one-swiper', {
			effect: 'fade',
			autoHeight: true,
			fadeEffect: {
				crossFade: true
			},
			navigation: {
				nextEl: '.swiper-navigation .swiper-button-next',
				prevEl: '.swiper-navigation .swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + swiperOptionTitles[index] + '</span>';
				},
			},
		});

		new Swiper('.photos-swiper', {
			slidesPerView: 'auto',
			centeredSlides: true,
			loop: true
		});

		new Swiper('.swiper-notes', {
			navigation: {
				nextEl: '.swiper-navigation .swiper-button-next',
				prevEl: '.swiper-navigation .swiper-button-prev',
			},
		});

		let lastId;
		const tabItems = $('.trainees .tabs a');
		const scrollItems = tabItems.map(function(){
			var item = $($(this).attr("href"));
			if (item.length) { return item; }
		});

		$(window).scroll(function(){
			const fromTop = $(this).scrollTop()+ 50;

			let current = scrollItems.map(function(){
				if ($(this).offset().top < fromTop)
					return this;
			});
			current = current[current.length-1];
			const id = current && current.length ? current[0].id : "";

			if (lastId !== id) {
				lastId = id;
				tabItems
					.removeClass("active")
					.filter("[href='#"+id+"']").addClass("active");
			}
		});

		if ($('.trainees').length) {
			gsap.to(".trainees .top .image-1",
				{
					scrollTrigger: {
						trigger: '.trainees .top',
						start: "5% top",
						scrub: true
					},
					y: "60%",
				});

			gsap.to(".trainees .top .image-2",
				{
					scrollTrigger: {
						trigger: '.trainees .top',
						start: "5% top",
						scrub: true
					},
					y: "-20%",
				});

			gsap.to(".trainees .top .subtitle",
				{
					scrollTrigger: {
						trigger: '.trainees .top',
						start: "5% top",
						scrub: true
					},
					y: "12px",
				});

			gsap.to(".trainees .top .caption",
				{
					scrollTrigger: {
						trigger: '.trainees .top',
						start: "5% top",
						scrub: true
					},
					y: "12px",
				});

			gsap.to(".trainees .top .icon-1",
				{
					scrollTrigger: {
						trigger: '.trainees .top',
						start: "5% top",
						end: "70% top",
						scrub: true
					},
					rotate: "-390deg",
				});

			gsap.to(".trainees .top .icon-2",
				{
					scrollTrigger: {
						trigger: '.trainees .top',
						start: "5% top",
						scrub: true
					},
					y: "20%",
				});

			gsap.to(".trainees .option-one  .option-wrapper .header .icon",
				{
					scrollTrigger: {
						trigger: '.trainees .option-one .header',
						start: "top 80%",
						end: "center 40%",
						scrub: true
					},
					scale: 1.2,
				});

			gsap.fromTo(".trainees .option-one  .option-wrapper .header h2",
				{y: 250,opacity:0},
				{
					scrollTrigger: {
						trigger: '.trainees .option-one .header',
						start: "top 80%",
						end: "center 40%",
						scrub: true,
					},
					y: 0,
					opacity: 1
				});

			gsap.to(".trainees .option-two .option-wrapper .header .icon",
				{
					scrollTrigger: {
						trigger: '.trainees .option-two .header',
						start: "top 80%",
						end: "center 40%",
						scrub: true
					},
					scale: 1.2,
				});

			gsap.fromTo(".trainees .option-two  .option-wrapper .header h2",
				{y: 250,opacity:0},
				{
					scrollTrigger: {
						trigger: '.trainees .option-two .header',
						start: "top 80%",
						end: "center 40%",
						scrub: true,
					},
					y: 0,
					opacity: 1
				});
		}
	});
}(jQuery));
